import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import officeStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/officeStyle.jsx";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Tooltip from "@material-ui/core/Tooltip";
// @material-ui/icons
import Mail from "@material-ui/icons/Email";

// office
import office1 from "assets/img/Kinos/AboutUs/office1.jpg";
import office2 from "assets/img/Kinos/AboutUs/office2.jpg";
import office3 from "assets/img/Kinos/AboutUs/office3.jpg";
import office4 from "assets/img/Kinos/AboutUs/office4.jpg";
import office5 from "assets/img/Kinos/AboutUs/office5.jpg";
import description from "assets/img/bg.jpg";

function SectionOffice(props) {
  const { classes } = props;
  return (
    <div className={classes.office}>

      <GridContainer>

        <GridItem xs={12} sm={12} md={12}>
          <Card
            raised
            background
            style={{ backgroundImage: "url(" + description + ")" }}
          >
            <CardBody background>
              <h6 className={classes.category}>KINOS</h6>
              <a href="#pablo">
                <h3 className={classes.cardTitle}>
                  More than 30.000 Customers
                </h3>
              </a>
              <p className={classes.category}>
                We help you to buy, build, occupy and invest in a variety of assets including industrial, commercial, retail, residential and hotel real estate. From investments funds, tech startups to global firms, our clients span industries including banking, energy, healthcare, law, life sciences, manufacturing and technology.

              </p>
              <Button round href="/contact-us" color="primary">
                <Mail className={classes.icons} /> Contact Us
              </Button>

            </CardBody>
          </Card>
        </GridItem>

        <GridItem md={6} sm={6}>
          <h3 className={classes.title}>Who we are?</h3>
          <h4>
            Kinos was established in 2003 by its founding  partners  Joaquín Morales and Margarita Morales  in the past decades, they has amassed a well-rounded resume of education and experience in business management and real estate. They has also established a strong network of contacts in the industry and ties to the Spain, Europe, USA and global community.  They manages the day-to-day operations of the firm as well as overseeing all areas of the operations.
          </h4>
        </GridItem>

        <GridItem md={6} sm={6}>
          <img
            className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}
            src={office1}
            alt="office1"
          />
        </GridItem>

        <GridItem md={6} sm={6}>
          <img
            className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}
            src={office2}
            alt="office2"
          />
        </GridItem>

        <GridItem md={6} sm={6}>
          <h3 className={classes.title}>Why Kinos?</h3>
          <h4>
          Kinos is a professional services and investment management firm offering specialised real estate services to clients seeking increased value by owning, occupying and investing in real estate.
We apply the tools of modern data science to commercial and residential real estate. For decades we have been analyzing﻿ market fundamentals with consistency across geographies and property types in Spain. Our data, analytics and macroeconomic viewpoints provide insight as clients evaluate the risks and opportunities that market changes may represent for their investment portfolios.
          </h4>
        </GridItem>

        <GridItem md={6} sm={6}>
          <h3 className={classes.title}>Aproach</h3>
          <h4>
            Kinos seeks to identify real estate related investment opportunities across Spain and Europe.We are seeking to generate attractive risk-adjusted returns with upside potential through capital appreciation or repositioning, with a particular focus on major metropolitan areas of the Spain and super-regional markets in Europe.
          </h4>
        </GridItem>

        <GridItem md={6} sm={6}>
          <img
            className={classNames(
              classes.imgRaised,
              classes.imgFluid,
              classes.rounded
            )}
            src={office4}
            alt="office4"
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(officeStyle)(SectionOffice);
